import { Calendar, Clock, User, ArrowRight } from "lucide-react";

const articles = [
  {
    id: 1,
    title: "Kenya's Luxury Real Estate Market: Trends & Opportunities 2024",
    excerpt: "An in-depth analysis of the current state of Kenya's premium property market, emerging trends, and investment opportunities for discerning buyers.",
    author: "Michael Kamau",
    date: "March 15, 2024",
    readTime: "8 min read",
    category: "Market Analysis",
    image: "https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?w=800&h=600&fit=crop"
  },
  {
    id: 2,
    title: "The Complete Guide to Buying Property in Karen, Nairobi",
    excerpt: "Everything you need to know about purchasing property in one of Nairobi's most prestigious neighborhoods, from legal requirements to market insights.",
    author: "Sarah Wanjiku",
    date: "March 10, 2024",
    readTime: "12 min read",
    category: "Buying Guide",
    image: "https://images.unsplash.com/photo-1570129477492-45c003edd2be?w=800&h=600&fit=crop"
  },
  {
    id: 3,
    title: "Coastal Living: Why Mombasa's Beachfront Properties Are in High Demand",
    excerpt: "Exploring the growing appeal of Mombasa's luxury beachfront properties and what makes Kenya's coast a prime investment destination.",
    author: "David Mwangi",
    date: "March 5, 2024",
    readTime: "6 min read",
    category: "Investment",
    image: "https://images.unsplash.com/photo-1533105079780-92b9be482077?w=800&h=600&fit=crop"
  },
  {
    id: 4,
    title: "Understanding Kenya's Property Laws: A Foreign Investor's Perspective",
    excerpt: "Navigating the legal landscape of Kenyan real estate investments, including land ownership laws and regulations for international buyers.",
    author: "Grace Ochieng",
    date: "February 28, 2024",
    readTime: "10 min read",
    category: "Legal",
    image: "https://images.unsplash.com/photo-1586281380349-632531db7ed4?w=800&h=600&fit=crop"
  },
  {
    id: 5,
    title: "The Rise of Smart Homes in Kenya's Luxury Real Estate",
    excerpt: "How technology and automation are transforming Kenya's high-end residential properties and what buyers should look for in modern homes.",
    author: "Tech Team",
    date: "February 20, 2024",
    readTime: "7 min read",
    category: "Technology",
    image: "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=800&h=600&fit=crop"
  },
  {
    id: 6,
    title: "Property Management: Maximizing Returns on Your Kenyan Real Estate Investment",
    excerpt: "Essential strategies for effective property management and rental income optimization in Kenya's competitive real estate market.",
    author: "James Njoroge",
    date: "February 15, 2024",
    readTime: "9 min read",
    category: "Management",
    image: "https://images.unsplash.com/photo-1448630360428-65456885c650?w=800&h=600&fit=crop"
  }
];

const BlogSection = () => {
  return (
    <section id="blog" className="bg-brand-canvas py-16 md:py-24">
      <div className="px-8 md:px-16 max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-20">
          <p className="font-body text-xs tracking-[0.3em] uppercase text-accent mb-6">
            Insights & Resources
          </p>
          <h2 className="font-display text-4xl md:text-6xl font-light text-primary-foreground mb-8">
            Latest Articles
          </h2>
          <div className="max-w-3xl mx-auto">
            <p className="font-body text-lg leading-relaxed text-primary-foreground/75">
              Expert insights, market analysis, and comprehensive guides to help you navigate 
              Kenya's luxury real estate landscape with confidence.
            </p>
          </div>
        </div>

        {/* Article Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          {articles.slice(0, 3).map((article) => (
            <article key={article.id} className="group overflow-hidden rounded-xl border border-border/30 bg-card/95 transition-all duration-300 hover:bg-card">
              <div className="relative aspect-[16/10] overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground/70 via-foreground/10 to-transparent" />
                <div className="absolute top-4 left-4">
                  <span className="inline-block px-3 py-1 bg-accent/90 text-accent-foreground rounded-full text-xs font-body font-medium backdrop-blur-sm">
                    {article.category}
                  </span>
                </div>
              </div>
              
              <div className="p-6">
                <h3 className="font-display text-xl font-light text-foreground mb-3 line-clamp-2 group-hover:text-accent transition-colors">
                  {article.title}
                </h3>
                <p className="font-body text-sm text-muted-foreground mb-4 line-clamp-3">
                  {article.excerpt}
                </p>
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-3 text-muted-foreground">
                    <div className="flex items-center gap-1">
                      <User className="w-3 h-3" />
                      <span className="font-body text-xs">{article.author}</span>
                    </div>
                    <div className="flex items-center gap-1">
                      <Clock className="w-3 h-3" />
                      <span className="font-body text-xs">{article.readTime}</span>
                    </div>
                  </div>
                  <a
                    href="#"
                    className="text-accent hover:text-accent/80 transition-colors"
                    aria-label={`Read ${article.title}`}
                  >
                    <ArrowRight className="w-4 h-4" />
                  </a>
                </div>
              </div>
            </article>
          ))}
        </div>

        {/* Call to Action */}
        <div className="text-center">
          <a
            href="#"
            className="inline-block font-body text-xs tracking-[0.25em] uppercase bg-accent text-accent-foreground px-10 py-4 hover:bg-foreground hover:text-background transition-colors duration-300"
          >
            View All Articles
          </a>
        </div>
      </div>
    </section>
  );
};

export default BlogSection;
